import { extendTailwindMerge } from 'tailwind-merge'

export const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'base',
            'lg1',
            'lg2',
            'lg3',
            'lg4',
            'lg5',
            'lg6',
            'sm1',
            'sm2',
            'sm3',
            'sm4',
            'sm5',
          ],
        },
      ],
    },
  },
})
